import { takeLatest, call, put, select } from 'redux-saga/effects';
import FileSaver from 'file-saver';
import moment from 'moment';
import {
  INIT_AI_DOWNLOADS,
  UPDATE_REMAINING_DOWNLOADS,
  GENERATE_AI_PHOTO,
  GENERATE_AI_PHOTO_SUCCESS,
  GENERATE_AI_PHOTO_ERROR,
  DOWNLOAD_AI_PHOTO,
  DOWNLOAD_AI_PHOTO_ERROR,
  DOWNLOAD_AI_PHOTO_SUCCESS,
} from './constants';
import { updateRemainingDownloads } from './actions';
import { makeSelectRemainingDownloads, makeSelectPhoto } from './selectors';
import Cookies from '~/services/Cookies';
import * as photoPageService from '~/services/photo-page';
import { showError } from '~/containers/CustomErrorMessage/actions';
import { fileHelper } from '~/utils';

function* generateAIPhoto(action) {
  const remainingDownloads = yield select(makeSelectRemainingDownloads());
  if (remainingDownloads === 0) return;
  try {
    const { ai_photo_url: photo } = yield call(
      photoPageService.generateAIPeoplePhoto,
    );

    yield put({
      type: GENERATE_AI_PHOTO_SUCCESS,
      photo,
    });
    yield put(updateRemainingDownloads(remainingDownloads - 1));
  } catch (error) {
    yield put(showError({ error }));
    yield put({
      type: GENERATE_AI_PHOTO_ERROR,
      error: true,
    });
  }
}

function* initAIDownloads(action) {
  const { req } = action;
  let downloadDay = Cookies.get('ai.downloadDay', req);
  let remainingDownloads = Cookies.get('ai.remainingDownloads', req);
  const today = moment().format('YYYY/MM/DD');
  const MAXIMUM_DOWNLOADS = 50;
  if (!downloadDay || downloadDay !== today) {
    downloadDay = today;
    remainingDownloads = MAXIMUM_DOWNLOADS;
  } else {
    remainingDownloads = parseInt(remainingDownloads);
  }
  Cookies.set('ai.downloadDay', downloadDay);
  yield put(updateRemainingDownloads(remainingDownloads));
}

// eslint-disable-next-line
function* updateRemainingDownloadsInCookies(action) {
  Cookies.set('ai.remainingDownloads', action.payload);
}

function* downloadAIPhoto(action) {
  try {
    const imageUrl = action.payload;
    const { data } = yield call(photoPageService.downloadAIPhoto, imageUrl);
    const fileName = imageUrl.split('/').pop();
    const image = `data:image/png;base64,${data}`;
    const blob = fileHelper.dataURItoBlob(image);
    FileSaver.saveAs(blob, fileName);
    yield put({ type: DOWNLOAD_AI_PHOTO_SUCCESS, payload: imageUrl });
  } catch (error) {
    yield put(
      showError({
        error,
      }),
    );
    yield put({ type: DOWNLOAD_AI_PHOTO_ERROR, error });
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export default function* aiPhotoSaga() {
  yield takeLatest(GENERATE_AI_PHOTO, generateAIPhoto);
  yield takeLatest(DOWNLOAD_AI_PHOTO, downloadAIPhoto);
  yield takeLatest(INIT_AI_DOWNLOADS, initAIDownloads);
  yield takeLatest(
    UPDATE_REMAINING_DOWNLOADS,
    updateRemainingDownloadsInCookies,
  );
}
